import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../lib/constants';
import UserDropdown from './UserDropdown';

export default function MainNavbar() {
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setUsername(null);
      return;
    }
    
    // Defensive check for axios availability
    try {
      if (axios && typeof axios.get === 'function') {
        axios.get(`${API_BASE_URL}/api/current-user/`)
          .then(res => setUsername(res.data.username))
          .catch(() => setUsername(null));
      } else {
        // Fallback for test environments
        setUsername(null);
      }
    } catch {
      // Extra safety for test environments
      setUsername(null);
    }
  }, []);

  return (
    <nav style={{ position: 'sticky', top: 0, left: 0, width: '100vw', background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 32px', height: 64, zIndex: 100, boxSizing: 'border-box' }}>
      <Link to="/" style={{ fontWeight: 800, fontSize: 22, color: '#2563eb', textDecoration: 'none', letterSpacing: 1 }}>Magic Fam Concierge</Link>
      <div style={{ display: 'flex', gap: 24, position: 'relative' }}>
        {username ? (
          <>
            <Link to="/dashboard" style={{ textDecoration: 'none', color: '#2d6cdf', fontWeight: 600 }}>Dashboard</Link>
            <Link to="/family" style={{ textDecoration: 'none', color: '#2d6cdf', fontWeight: 600 }}>Family</Link>
            <Link to="/recipes" style={{ textDecoration: 'none', color: '#2d6cdf', fontWeight: 600 }}>Recipes</Link>
            <UserDropdown username={username} />
          </>
        ) : (
          <>
            <Link to="/login" style={{ textDecoration: 'none', color: '#2d6cdf', fontWeight: 600 }}>Login</Link>
            <Link to="/sign-up" style={{ textDecoration: 'none', color: '#2d6cdf', fontWeight: 600 }}>Sign Up</Link>
          </>
        )}
      </div>
    </nav>
  );
}
